import { render, staticRenderFns } from "./BSCarouselOptions.vue?vue&type=template&id=6718c4e9"
import script from "./BSCarouselOptions.vue?vue&type=script&lang=js"
export * from "./BSCarouselOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports